import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import Grid from '~/components/core/Atomic/Grid/Grid';
import { useCms } from '~/components/hooks/useCms';
import { usePaymentsConfiguration } from '~/components/hooks/usePaymentsConfiguration';
import LEGACY_ORG_FEATURES from '~/server_shared/generated-types/LEGACY_ORG_FEATURES';

import { isLegacyOrgFeatureEnabled } from '../../../Utils';
import { ContactShowOnlyTextField } from '../../ContactTextFieldFormik';
import TextFieldFormik, { ShowOnlyTextField } from '../../TextFieldFormik';

import MailToParagraph from './MailToParagraph';
import PaymentPayeesShowOnly from './PaymentPayeesShowOnly';
import PayToParagraph from './PayToParagraph';

import { useStyles } from '../../../assets/styles';

function VendorExpensePayee({ paymentRequest }) {
  const vendorPayee = paymentRequest.payees.find((payee) => payee.payee_type === 'vendor').contact;

  return (
    <ContactShowOnlyTextField
      contactId={vendorPayee.id}
      contactDisplayName={vendorPayee.full_name}
      label="Vendor"
      showOnly
    />
  );
}

VendorExpensePayee.propTypes = {
  paymentRequest: PropTypes.object.isrequierd,
};

function ExpensesPayeesFormikShowOnly(props) {
  const { paymentRequest } = props;
  const { userOrganization } = useCms();
  const {
    shouldUseMail,
    shouldUseIbanBankTransfer,
    expensePaymentTypes,
    isOneIncPayment,
    shouldUseUKBankTransfer,
    shouldUseAuBankTransfer,
    shouldUseUsAch,
  } = usePaymentsConfiguration(paymentRequest.payment_method);
  const shouldUsePaymentRequestStoreForExpenses = isOneIncPayment;
  const { values } = useFormikContext();
  const expenseType = values.expense_type;
  const { classes } = useStyles();

  return (
    <div>
      <ShowOnlyTextField
        classes={classes}
        showOnlyValueComponent={expenseType ? expensePaymentTypes[expenseType]?.desc || expenseType : ''}
        label="Payment Type"
      />
      {shouldUsePaymentRequestStoreForExpenses ? (
        <PaymentPayeesShowOnly paymentRequest={paymentRequest} />
      ) : (
        <VendorExpensePayee paymentRequest={paymentRequest} />
      )}

      <PayToParagraph paymentRequest={paymentRequest} />

      {shouldUseIbanBankTransfer && (
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextFieldFormik id="iban" label="IBAN" className={classes.textFieldRow} showOnly fullWidth />
          </Grid>
          <Grid item xs={6}>
            <TextFieldFormik id="reference" label="Reference" className={classes.textFieldRow} showOnly fullWidth />
          </Grid>
        </Grid>
      )}

      {shouldUseUKBankTransfer && (
        <>
          <ShowOnlyTextField
            classes={classes}
            showOnlyValueComponent={paymentRequest.uk_sort_code}
            label="Sort Number"
          />
          <ShowOnlyTextField
            classes={classes}
            showOnlyValueComponent={paymentRequest.uk_bank_account_number}
            label="Account Number"
          />
          <ShowOnlyTextField
            label="Payment Reference"
            showOnlyValueComponent={paymentRequest.reference}
            classes={classes}
          />
        </>
      )}

      {shouldUseAuBankTransfer && (
        <>
          <ShowOnlyTextField
            classes={classes}
            showOnlyValueComponent={paymentRequest.au_bsb_number}
            label="BSB Number"
          />
          <ShowOnlyTextField
            classes={classes}
            showOnlyValueComponent={paymentRequest.au_bank_account_number}
            label="Account Number"
          />
          <ShowOnlyTextField
            label="Payment Reference"
            showOnlyValueComponent={paymentRequest.reference}
            classes={classes}
          />
        </>
      )}

      {shouldUseUsAch && (
        <>
          <ShowOnlyTextField
            classes={classes}
            showOnlyValueComponent={paymentRequest.us_routing_number}
            label="Routing Number"
          />
          <ShowOnlyTextField
            classes={classes}
            showOnlyValueComponent={paymentRequest.us_bank_account_number}
            label="Account Number"
          />
          <ShowOnlyTextField classes={classes} showOnlyValueComponent={paymentRequest.us_bank_name} label="Bank Name" />
          <ShowOnlyTextField
            label="Payment Reference"
            showOnlyValueComponent={paymentRequest.reference}
            classes={classes}
          />
        </>
      )}

      {!isLegacyOrgFeatureEnabled(userOrganization, LEGACY_ORG_FEATURES.QOVER_HIDE_EXPENSE_INVOICE_NUMBER) && (
        <TextFieldFormik id="invoice_number" label="Invoice #" fullWidth showOnly className={classes.textField} />
      )}

      {shouldUseMail && <MailToParagraph paymentRequest={paymentRequest} />}
    </div>
  );
}

ExpensesPayeesFormikShowOnly.propTypes = {
  paymentRequest: PropTypes.object.isRequired,
};

export default ExpensesPayeesFormikShowOnly;
